module.exports = "https://cdn2-fs.clearscore.com/flux/images/6ed9b4e0bfe0e8ac71337edf013c5dfd.jpg";